import type { GemStack } from "../types";

/** Last luck stone level chosen for gear enhance — current browser session only. */
let lastEnhanceLuckLevel: number | null = null;

export function getSessionEnhanceLuckLevel(): number | null {
  return lastEnhanceLuckLevel;
}

export function setSessionEnhanceLuckLevel(level: number): void {
  lastEnhanceLuckLevel = level;
}

export function resolveAvailableSessionLuckLevel(luckStacks: GemStack[]): number | null {
  if (lastEnhanceLuckLevel == null) return null;
  if (lastEnhanceLuckLevel === 0) return 0;
  return luckStacks.some((s) => s.level === lastEnhanceLuckLevel && s.quantity > 0)
    ? lastEnhanceLuckLevel
    : null;
}

export function initialEnhanceLuckLevel(luckStacks: GemStack[]): number {
  const session = getSessionEnhanceLuckLevel();
  if (session == null) return 0;
  if (session === 0) return 0;
  return luckStacks.some((s) => s.level === session && s.quantity > 0) ? session : 0;
}
